import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Dashboard from '../pages/tm/dashboard';
import Investigation from '../pages/tm/investigation';
import InvestigationDetail from '../pages/tm/investigationDetail';
import Settings from '../pages/settings';

import { tmHasPermission } from '../util';
import { getItemFromLocalStorage } from '../util/localStorageUtils';
import { ROUTE_AMLS_TM_SAM } from '../pages/constants/globalConstants';
import {
  TM_TAB_LIST,
  TM_TAB_PAGEID_LIST
} from '../pages/constants/tmConstants';
import { getSelectedResources } from '../util/resourceManager';

const { tmResources } = getSelectedResources();
const TMSettings = () => (
  <Settings
    title="Global Setting for Transaction Monitoring"
    tmTabList={TM_TAB_LIST}
    tmTabPageIdList={TM_TAB_PAGEID_LIST}
    GlobalSettingPageType={'TM'}
  />
);

export default (authentication) => {
  const NoAccess = () => {
    return <div>No Access</div>;
  };

  //protect route by user role
  const RestrictedRender = (Component) => {
    return tmHasPermission(authentication) ? (
      <Component></Component>
    ) : (
      <NoAccess></NoAccess>
    );
  };

  let riskViewPermitted = false;
  let alertsListingPermitted = false;
  let investigationPagePermitted = false;
  let globalSettingsPermitted = false;
  let trmDashboardPermitted = false;
  let homeUrl = null;

  const investigationRoute = `${ROUTE_AMLS_TM_SAM}/investigation`;
  const dashboardRoute = `${ROUTE_AMLS_TM_SAM}/dashboard`;
  const settingsRoute = `${ROUTE_AMLS_TM_SAM}/settings`;

  if (
    authentication &&
    Array.isArray(authentication.data) &&
    authentication.data.length > 0
  ) {
    // list of Attributes
    const listOfAttributes = authentication.data;

    listOfAttributes.map((attribute) => {
      const resourceCode = attribute.details?.resource?.resourceCode
        ? attribute.details.resource.resourceCode
        : null;
      const scopes = attribute.details?.resource?.operations
        ? attribute.details.resource.operations
        : null;

      if (scopes) {
        if (scopes.includes(tmResources.APP_3_RESOURCE_UI_TM_IAD_FULLACCESS)) {
          trmDashboardPermitted = true;
        }

        if (
          scopes.includes(tmResources.APP_3_RESOURCE_UI_TM_ALERT_LIST_ALERTS)
        ) {
          alertsListingPermitted = true;
        }

        if (
          scopes.includes(tmResources.APP_3_RESOURCE_UI_TM_ALERT_LIST_ANOMALIES)
        ) {
          alertsListingPermitted = true;
        }

        if (
          scopes.includes(tmResources.APP_3_RESOURCE_UI_TM_INVESTIGATION_PAGE)
        ) {
          investigationPagePermitted = true;
        }

        if (scopes.includes(tmResources.APP_3_RESOURCE_UI_TM_DASHBOARD)) {
          riskViewPermitted = true;
        }

        if (
          scopes.includes(tmResources.APP_3_RESOURCE_UI_TM_GLOBAL_SETTINGS) &&
          getItemFromLocalStorage('settings-enabled') === 'true'
        ) {
          globalSettingsPermitted = true;
        }
      }
    });

    if (trmDashboardPermitted) {
      homeUrl = '/app/trm/dashboard';
    } else if (investigationPagePermitted) {
      homeUrl = investigationRoute;
    } else if (riskViewPermitted) {
      homeUrl = dashboardRoute;
    }
  }

  const routes = (
    <Switch>
      {/* Set the route for the landing page */}
      {homeUrl ? (
        <Route exact path="/app" render={() => <Redirect to={homeUrl} />} />
      ) : null}

      <Route
        exact
        path={ROUTE_AMLS_TM_SAM}
        render={() => <Redirect to={homeUrl} />}
      />

      {riskViewPermitted ? (
        <Route
          exact
          path={dashboardRoute}
          render={() => {
            return RestrictedRender(Dashboard);
          }}
        />
      ) : null}

      {alertsListingPermitted ? (
        <Route
          exact
          path={investigationRoute}
          render={() => {
            return RestrictedRender(Investigation);
          }}
        />
      ) : null}

      {investigationPagePermitted ? (
        <Route
          exact
          path={`${investigationRoute}/:alertId`}
          component={InvestigationDetail}
        />
      ) : null}

      {globalSettingsPermitted ? (
        <Route
          exact
          path={settingsRoute}
          render={() => {
            return RestrictedRender(TMSettings);
          }}
        />
      ) : null}
    </Switch>
  );
  return routes;
};
